<template>
  <div class="linkage-box">
    <div>
      <div class="label">选择节点</div>
      <div class="select-box box">
        <div class="box-head">
          <div class="manager">管理员</div>
          <div class="node">节点</div>
        </div>
        <div class="box-body">
          <div class="manager">
            <div v-show="admins.length === 0" class="none">没有管理员</div>
            <el-checkbox-group v-model="checkedAdmin" :min="0" :max="1" @change="handleAdminChange">
              <el-checkbox
                v-for="ele in admins"
                :key="ele.AdminID"
                :label="`${ele.AdminID}`"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="node">
            <div v-show="nodes.length === 0" class="none">没有节点</div>
            <el-checkbox-group v-model="checkedNode" :min="0" :max="1" @change="handleNodeChange">
              <el-checkbox
                v-for="ele in nodes"
                :key="ele.NodeID"
                :label="`${ele.NodeID} ( ${ele.Count}nodes )`"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="label">已选择</div>
      <div class="select-box box">
        <div class="box-head">
          <div class="manager">管理员</div>
          <div class="node">节点</div>
        </div>
        <div class="box-body">
          <div class="manager">
            <div class="manager-list">
              <div
                v-for="(ele, index) in selectAdminDetails"
                :key="index"
                class="manager-list-item"
              >
                <span>{{ ele.AdminName }}</span>
              </div>
            </div>
          </div>
          <div class="node">
            <div class="node-list">
              <div v-for="(ele, index) in selectNodeDetails" :key="index" class="node-list-item">
                <span>{{ ele.NodeName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="tips">
        <span
          v-if="selectAdminDetails.length === 0 && selectNodeDetails.length === 0"
          class="none-tip"
        >
          <i class="el-icon-warning-outline"></i>请选择管理员和节点
        </span>
        <span
          v-else-if="selectAdminDetails.length > 0 && selectNodeDetails.length === 0"
          class="none-tip"
        >
          <i class="el-icon-warning-outline"></i>请选择节点
        </span>
        <span
          v-if="selectAdminDetails.length === 0 && selectNodeDetails.length > 0"
          class="none-tip"
        >
          <i class="el-icon-warning-outline"></i>请选择管理员
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DposLinkageBox',
  props: {
    algoForm: {
      type: Object,
      default: () => {
        return {
          Algorithm: 0
        }
      }
    },
    consensus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      admins: [],
      nodes: [],
      selectAdminDetails: [],
      selectNodeDetails: [],
      checkedAdmin: [],
      checkedNode: [],
      algoType: this.algoForm.Algorithm
    }
  },
  watch: {
    algoForm: {
      deep: true,
      handler(val) {
        // 通知节点改变
        this.$emit('update:node', [])
        this.changeAlgo(val.Algorithm)
      }
    }
  },
  created() {
  },
  mounted() {
    this.refresh()
  },
  methods: {
    // 修改算法
    changeAlgo(algo) {
      this.algoType = algo
      this.checkedAdmin = []
      this.checkedNode = []
      this.selectAdminDetails = []
      this.selectNodeDetails = []
      this.refresh()
    },
    handleAdminChange(adminIDs) {
      let self = this
      if (adminIDs && adminIDs.length > 0) {
        let adminID = adminIDs[0]
        this.$apis.chain
          .queryAdminDetails({
            AdminID: adminID
          })
          .then(data => {
            if (data && data && data.data.items) {
              self.selectAdminDetails = data.data.items
            } else {
              self.selectAdminDetails = []
            }
          })
          .catch(e => {
            self.selectAdminDetails = []
          })
      } else {
        self.selectAdminDetails = []
      }
    },
    handleNodeChange(nodeIDs) {
      let self = this
      if (nodeIDs && nodeIDs.length > 0) {
        let [nodeID] = nodeIDs[0].split(' ')
        this.$apis.chain
          .queryNodeDetails({
            NodeID: nodeID
          })
          .then(data => {
            if (data && data.data && data.data.items) {
              self.selectNodeDetails = data.data.items
              let selectedNodes = self.selectNodeDetails.map(e => e.NodeName)

              for (let i = 0; i < selectedNodes.length; i++) {
                this.$nextTick(() => {
                  self.$emit('update:node', selectedNodes.slice(0, i + 1))
                })
              }
            } else {
              self.selectNodeDetails = []
              self.$emit('update:node', [])
            }
          })
          .catch(e => {
            self.selectNodeDetails = []
            self.$emit('update:node', [])
          })
      } else {
        self.selectNodeDetails = []
        self.$emit('update:node', [])
      }
    },
    refresh() {
      let self = this
      this.$apis.chain
        .queryAdmins({
          Algorithm: this.algoType
        })
        .then(data => {
          if (data && data.data && data.data.items) {
            self.admins = data.data.items
          } else {
            self.admins = []
          }
        })
      this.$apis.chain
        .queryNodes({
          Algorithm: this.algoType
        })
        .then(data => {
          if (data && data.data && data.data.items) {
            self.nodes = data.data.items
          } else {
            self.nodes = []
          }
        })
    },
    getData() {
      if (this.selectAdminDetails.length == 0 && this.selectNodeDetails.length == 0) {
        this.$message.warning('请选择管理员和节点')
        this.$emit('change:disable')
        return false
      } else if (this.selectAdminDetails.length > 0 && this.selectNodeDetails.length == 0) {
        this.$message.warning('请选择管理员')
        this.$emit('change:disable')
        return false
      } else if (this.selectAdminDetails.length == 0 && this.selectNodeDetails.length > 0) {
        this.$message.warning('请选择节点')
        this.$emit('change:disable')
        return false
      } else {
        return {
          DposAdminID: this.checkedAdmin[0],
          DposNodes: this.selectNodeDetails
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'linkage-box',
  (
    --linkage-box-color: #fff,
    --linkage-box-border-color: #33496e,
    --linkage-box-background-color: #303c65,
    --linkage-box-none-tip-color: #c0c4cc,
    --linkage-box-tip-color: #f56c6c,
    --linkage-box-box-content-node-none-color: #c0c4cc
  ),
  (
    --linkage-box-color: #192227,
    --linkage-box-border-color: #ebebeb,
    --linkage-box-background-color: #f4f4f5,
    --linkage-box-none-tip-color: #c0c4cc,
    --linkage-box-tip-color: #f56c6c,
    --linkage-box-box-content-node-none-color: #c0c4cc
  )
);
.linkage-box {
  @include adaptation(
    (
      --linkage-box-font-size: 12px,
      --linkage-box-tips-font-size: 14px,
      --linkage-box-label-margin-bottom: 8px,
      --linkage-box-box-width: 390px,
      --linkage-box-box-height: 370px,
      --linkage-box-box-margin-right: 24px,
      --linkage-box-border-width: 1px,
      --linkage-box-box-head-padding: 0 16px,
      --linkage-box-box-head-height: 40px,
      --linkage-box-box-head-manager-col-width: 130px,
      --linkage-box-box-content-padding: 12px 16px,
      --linkage-box-box-content-item-height: 36px,
      --linkage-box-box-content-checkbox-height: 36px,
    )
  );
  display: flex;
  align-items: center;
  font-size: var(--linkage-box-font-size);
  color: var(--linkage-box-color);
  .label {
    margin-bottom: var(--linkage-box-label-margin-bottom);
  }
  .box {
    width: var(--linkage-box-box-width);
    height: var(--linkage-box-box-height);
    border: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
    margin-right: var(--linkage-box-box-margin-right);
    .box-head {
      display: flex;
      align-items: center;
      height: var(--linkage-box-box-head-height);
      line-height: var(--linkage-box-box-head-height);
      border-bottom: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
      background-color: var(--linkage-box-background-color);
      .manager {
        padding: var(--linkage-box-box-head-padding);
        width: var(--linkage-box-box-head-manager-col-width);
        border-right: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
      }
      .node {
        flex: 1;
        padding: var(--linkage-box-box-head-padding);
      }
    }
    .box-body {
      height: calc(var(--linkage-box-box-height) - var(--linkage-box-box-head-height));
      display: flex;
      align-items: center;
      .manager {
        width: var(--linkage-box-box-head-manager-col-width);
        height: 100%;
        padding: var(--linkage-box-box-content-padding);
        overflow-y: auto;
        border-right: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
        .el-checkbox {
          height: var(--linkage-box-box-content-checkbox-height);
        }
        .manager-list-item {
          height: var(--linkage-box-box-content-item-height);
          line-height: var(--linkage-box-box-content-item-height);
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .node {
        flex: 1;
        height: 100%;
        padding: var(--linkage-box-box-content-padding);
        overflow-y: auto;
        .el-checkbox {
          height: var(--linkage-box-box-content-checkbox-height);
        }
        .node-list-item {
          height: var(--linkage-box-box-content-item-height);
          line-height: var(--linkage-box-box-content-item-height);
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .none {
        color: var(--linkage-box-box-content-node-none-color);
      }
    }
  }
  .tips {
    font-size: var(--linkage-box-tips-font-size);
    color: var(--linkage-box-none-tip-color);
    .error-tip {
      color: var(--linkage-box-tip-color);
    }
  }
}
</style>
